import { MapPin } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function BranchSwitcher() {
  const {
    user,
    gyms,
    rootGymId,
    canSwitchBranch,
    selectedBranchId,
    setSelectedBranchId,
    selectedBranch,
    isSwitchingBranch,
  } = useAuth();

  if (!user) {
    return null;
  }

  if (!canSwitchBranch) {
    return (
      <div className="flex h-8 w-full min-w-0 items-center gap-1.5 rounded-md border border-border/70 bg-muted/35 px-2 text-xs text-foreground sm:h-10 sm:gap-2 sm:rounded-full sm:bg-background sm:px-3 sm:shadow-sm">
        <MapPin className="h-3.5 w-3.5 shrink-0" />
        <span className="min-w-0 truncate text-[13px]">
          {selectedBranch?.name}
        </span>
      </div>
    );
  }

  return (
    <Select
      value={selectedBranchId}
      onValueChange={setSelectedBranchId}
      disabled={isSwitchingBranch || gyms.length === 0}
    >
      <SelectTrigger className="h-8 w-full min-w-0 rounded-md border border-border/70 bg-muted/35 px-2 text-xs shadow-none sm:h-10 sm:rounded-full sm:bg-background sm:px-3 sm:shadow-sm [&>span]:truncate">
        <MapPin className="mr-1 h-3.5 w-3.5 shrink-0 text-muted-foreground sm:mr-1.5" />
        <SelectValue placeholder="Select a branch" />
      </SelectTrigger>
      <SelectContent>
        {gyms.map((branch) => (
          <SelectItem
            key={branch._id}
            value={branch._id}
            endAdornment={branch._id === rootGymId ? (
              <span className="inline-flex rounded-full border border-blue-200 bg-blue-50 px-2 py-0.5 text-[10px] font-semibold leading-none text-blue-700">
                Main
              </span>
            ) : undefined}
          >
            {branch.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
